import React, { Component } from "react";
import styled, { css } from "styled-components";

import withTheme from "../styles/withTheme";

const HeaderComponent = styled.header`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 50px;
  padding-left: 200px;
  z-index: 1000;
  ${props =>
    css`
      background-color: ${props.mainVisual};
    `};
`;
const HeaderLeft = styled.div`
  position: absolute;
  left: 15px;
  top: 0;
  height: 50px;
  width: 200px;
  ${props =>
    css`
      background: url(${props.logo}) no-repeat 0;
    `} background-size: auto 25px;
`;

export class Header extends Component {
  // eslint-disable-next-line
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <HeaderComponent {...this.props}>
        <HeaderLeft {...this.props} />
        {this.props.children}
      </HeaderComponent>
    );
  }
}

export const mapThemeToProps = theme => {
  return {
    mainVisual: theme.color.mainVisual
  };
};

export default withTheme(mapThemeToProps)(Header);



// WEBPACK FOOTER //
// ./src/legacy-tv-ui/Header/Header.js